import { Table } from 'antd';
import React from 'react'

const columns = [
  {
      title: 'ID',
      dataIndex: 'id'
  },
  {
      title: 'Transaction Date',
      dataIndex: 'transactionDate'
  },
  {
      title: 'Transaction Type',
      dataIndex: 'transactionType'
  },
  {
      title: 'Debit',
      dataIndex: 'debit'
  },
  {
      title: 'Credit',
      dataIndex: 'credit'
  },
  {
    title: 'Balance',
    dataIndex: 'balance'
}
];

const Transactions = (props) => {

  const {transactionsList} = props

  return (
       <Table
    columns={columns}
    dataSource={transactionsList}
    />
  )
}

export default Transactions